import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import ModalPortal from '@Components/Popups/ModalPortal'
import WelcomePopup from '@Components/Popups/WelcomePopup'
import { StoresContext } from '@App/contexts'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import MemberSummarySection from '@Scenes/HomeScene/MemberSummarySection'
import SongwriterSummarySection from '@Scenes/HomeScene/SongwriterSummarySection'
import MemberHeader from '@Scenes/HomeScene/MemberHeader'
import SongwriterHeader from '@Scenes/HomeScene/SongwriterHeader'
import HomeSceneWrapper from '@Components/HomeSceneWrapper'
import { useFlag } from '@openfeature/react-sdk'

const HomeScene = observer(() => {
    const [welcomePopupIsOpen, setWelcomePopupIsOpen] = useState(false)
    const { userStore, uiStore } = useContext(StoresContext)
    const { value: allowNewUserSceneRedirect } = useFlag('member-songwriter-signup-rework', false)

    const checkWelcomePopup = () => {
        const userSettings = userStore.userInfo?.settings
        setWelcomePopupIsOpen(!(userSettings && 'showWelcomePopup' in userSettings && !userSettings.showWelcomePopup))
    }

    useEffect(() => {
        analyticsSendPage('home')
        checkWelcomePopup()
    }, [])

    const isMemberHome = uiStore.homePageState === 'member'

    return (
        <>
            <title>Home</title>
            <HomeSceneWrapper
                header={isMemberHome ? <MemberHeader /> : <SongwriterHeader />}
                wrapperClass={isMemberHome ? 'member-home' : 'songwriter-home'}
            >
                {isMemberHome ? <MemberSummarySection /> : <SongwriterSummarySection />}
            </HomeSceneWrapper>
            {!allowNewUserSceneRedirect && (
                <ModalPortal isOpen={welcomePopupIsOpen}>
                    <WelcomePopup onClose={() => setWelcomePopupIsOpen(false)} />
                </ModalPortal>
            )}
        </>
    )
})

export default HomeScene
